import { useRouteMatch } from 'react-router';

import Budget from 'pages/Private/SAC/Budget';
import { BudgetSacGraphic } from 'pages/Private/SAC/BudgetSacGraphic';

import { Route } from '../Route';

export const SacRoutes = () => {
  const { url } = useRouteMatch();

  return (
    <>
      <Route isPrivate path={`${url}/graphic/budget`} component={BudgetSacGraphic} />
      <Route isPrivate path={`${url}/budget`} component={Budget} />
    </>
  );
};
